import { render, staticRenderFns } from "./Modality.vue?vue&type=template&id=e5fa3b76"
import script from "./Modality.vue?vue&type=script&lang=js"
export * from "./Modality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5fa3b76')) {
      api.createRecord('e5fa3b76', component.options)
    } else {
      api.reload('e5fa3b76', component.options)
    }
    module.hot.accept("./Modality.vue?vue&type=template&id=e5fa3b76", function () {
      api.rerender('e5fa3b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/tabs/Modality.vue"
export default component.exports